import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import Icon from '../../../../../../muiComponents/Icon';
import { AgencyTypeLogState } from '../../../../types/zitoneoServicesTypes';
import ConnectivityLogsAgencyTypeRow from './ConnectivityLogsAgencyTypeRow';

interface ConnectivityLogsAgencyProps {
    agency: string;
    types: AgencyTypeLogState[];
}

const ConnectivityLogsAgency = ({
    agency,
    types,
}: ConnectivityLogsAgencyProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div className='connectivity-logs-panel__agency'>
            <div
                className='connectivity-logs-panel__agency-header cursor-pointer'
                onClick={() => setIsCollapsed(prev => !prev)}
            >
                <p className='connectivity-logs-panel__agency-title'>
                    {agency}
                </p>
                <Icon
                    iconName={
                        isCollapsed ? 'KeyboardArrowDown' : 'KeyboardArrowUp'
                    }
                />
            </div>
            <Collapse in={!isCollapsed} timeout='auto' unmountOnExit>
                <div className='flex-column gap-10 padding-top-16'>
                    {types.map(typeLog => (
                        <ConnectivityLogsAgencyTypeRow
                            key={typeLog.typeKey}
                            typeLog={typeLog}
                        />
                    ))}
                </div>
            </Collapse>
        </div>
    );
};

export default ConnectivityLogsAgency;
